// Lifecycle presentation for asset-list flags and the selected asset card.
export const LIFECYCLE_FLAG_CLASSES = {
  active: 'bg-[#6ACF7B]',
  working: 'bg-[#FFB300]',
  ideas: 'bg-[#2962FF]',
  'recently closed': 'bg-[#FF4D5B]',
  closed: 'bg-[#FF4D5B]',
}

export function assetLifecyclePresentation(stage) {
  const normalized = String(stage || '').trim().toLowerCase()
  const key = { idea: 'ideas', planned: 'ideas', reviewed: 'closed', 'recently-closed': 'recently closed' }[normalized] || normalized
  // Past trade completion is history, not a current asset status.
  if (!['active', 'working', 'ideas'].includes(key)) return null
  const colorClass = LIFECYCLE_FLAG_CLASSES[key]
  const label = { active: 'Active', working: 'Working', ideas: 'Idea', closed: 'Closed', 'recently closed': 'Recently closed' }[key]
  const pillClass = {
    active: 'bg-forest/10 text-forest border-forest/20',
    working: 'bg-[#c4953a]/10 text-[#c4953a] border-[#c4953a]/30',
    ideas: 'bg-blue-500/10 text-blue-400 border-blue-400/30',
    closed: 'bg-canvas2 text-inkMuted border-border',
    'recently closed': 'bg-canvas2 text-inkMuted border-border',
  }[key]
  return colorClass ? { pillClass, label } : null
}
